import {
  ContentfulHomePage2Query,
  ContentfulHomePage2QueryVariables,
} from "@outschool/gql-frontend-generated";
import { useLocale } from "@outschool/localization";
import { QueryResult, useQueryWithPreviousData } from "@outschool/ui-apollo";

import ContentfulHomePage2 from "../HomePage/ContentfulHomePage2Query";

type HomePageQueryResult = {
  loading: boolean;
  error?: QueryResult["error"];
  // @ts-ignore TS(2339): Property 'items' does not exist on type '{ __typen... Remove this comment to see the full error message
  items?: ContentfulHomePage2Query["contentfulHomePage2Collection"]["items"][number]["visualLinkGridsCollection"]["items"];
};

export default function useContentfulHomePage2Query(): HomePageQueryResult {
  const locale = useLocale();

  const { data, error } = useQueryWithPreviousData<
    ContentfulHomePage2Query,
    ContentfulHomePage2QueryVariables
  >(ContentfulHomePage2, {
    variables: {
      locale,
      preview: false,
    },
  });

  if (!!error) {
    return {
      error,
      loading: false,
    };
  }

  const items =
    data?.contentfulHomePage2Collection?.items?.[0]?.visualLinkGridsCollection
      ?.items;

  if (!items) {
    return {
      loading: true,
    };
  }

  return {
    loading: false,
    items,
  };
}
